"use client";
import { ThumbsUp } from "lucide-react";
import { useSession } from "next-auth/react";
import { addReviewLiked } from "@/utils/action/data";
import { useRouter } from "next/navigation";

const AddLike = ({ product, review, userData }) => {
  const session = useSession();
  const isExist = review?.likedBy?.includes(userData?._id);
  const router = useRouter();

  const handleReviewLiked = async () => {
    if (!session?.data?.user?.email) {
      router.push("/login");
    }

    const reviewData = {
      userId: userData?._id,
      productId: product?._id,
      reviewId: review?._id,
    };

    const data = await addReviewLiked(reviewData);

    if (data?.success) {
      window.location.reload();
    }
  };

  return (
    <div>
      <ThumbsUp
        onClick={() => handleReviewLiked()}
        size={16}
        strokeWidth={isExist ? 4 : 2}
        className={`cursor-pointer transition-colors ${
          isExist ? "text-brand-sky" : "text-muted-foreground hover:text-brand-sky"
        }`}
      />
    </div>
  );
};

export default AddLike;